module.exports = __webpack_public_path__ + "img/drug-pills.401921df.svg";